module.exports = __webpack_public_path__ + "img/gd.cf0bd3e4.png";